/* Fun Cases — phone.js
   Persistent "my phone" model selector. The chosen model is stored as a cart
   attribute (so Liquid can render the matching variant image everywhere) and
   mirrored to localStorage. Changing it reloads so the whole page re-renders
   for that model. */

(function () {
  'use strict';

  var KEY = 'fc_phone_model';
  var picker = document.querySelector('[data-phone-picker]');

  function openPicker() {
    if (!picker) return;
    picker.classList.add('is-open');
    picker.setAttribute('aria-hidden', 'false');
    document.body.classList.add('phone-open');
    showGuess();
    // No auto-focus: focusing the search mid-slide made the browser jerk the panel
    // into view (a janky entrance). Match the cart drawer — clean slide, tap to search.
  }

  /* Best-effort "we think your phone is…" guess. Exact where possible (Pixel via
     UA, iPhone via screen size), otherwise a family hint. */
  function guessPhone() {
    var ua = navigator.userAgent || '';
    var px = ua.match(/Pixel \d+[a-z]*/i);
    if (px) return 'Google ' + px[0].replace(/\s+/g, ' ').trim();
    var gx = ua.match(/Galaxy [A-Za-z0-9+ ]+/);
    if (gx) return gx[0].trim();
    if (/iPhone/.test(ua)) {
      var w = Math.min(screen.width, screen.height), h = Math.max(screen.width, screen.height);
      var map = {
        '440x956': 'iPhone 16 Pro Max', '430x932': 'iPhone 15 Pro Max', '428x926': 'iPhone 14 Plus',
        '414x896': 'iPhone 11', '402x874': 'iPhone 16 Pro', '393x852': 'iPhone 15',
        '390x844': 'iPhone 14', '375x812': 'iPhone 13 Mini', '375x667': 'iPhone 6 7 8 SE', '320x568': 'iPhone SE'
      };
      return map[w + 'x' + h] || 'an iPhone';
    }
    return null;
  }
  function modelExists(name) {
    return !!picker.querySelector('[data-model="' + (name || '').replace(/"/g, '') + '"]');
  }
  function modelSet() {
    var b = document.querySelector('[data-phone-set]');
    if (b && b.getAttribute('data-phone-set') === '1') return true;
    try { if (localStorage.getItem(KEY)) return true; } catch (e) {}
    return false;
  }
  function showGuess() {
    var el = picker && picker.querySelector('[data-pp-guess]');
    if (!el || el.dataset.done) return;
    /* Don't show "we think you have…" once the shopper has picked a model. */
    if (modelSet()) { el.hidden = true; return; }
    el.dataset.done = '1';
    var g = guessPhone();
    if (!g) return;
    if (modelExists(g)) {
      el.innerHTML = 'We think you have <strong>' + g + '</strong>. <button type="button" class="pp-guess__use" data-model="' + g + '">That’s me &rarr;</button>';
    } else {
      el.innerHTML = 'Looks like you’re on <strong>' + g + '</strong> — find your exact model below.';
    }
    el.hidden = false;
  }
  function closePicker() {
    if (!picker) return;
    picker.classList.remove('is-open');
    picker.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('phone-open');
  }

  function setModel(model) {
    try { if (model) localStorage.setItem(KEY, model); else localStorage.removeItem(KEY); } catch (e) {}
    // Preserve the currently-selected case type across the reload (else a Tough/MagSafe PDP —
    // e.g. landed on from Google Shopping — resets to Standard). Carry it in ?ct= so the PDP
    // re-selects it after the model changes. Drop ?variant (it's the OLD model's variant id).
    var target = null;
    try {
      var ctEl = document.querySelector('[data-pdp-ct] input:checked');
      var ct = ctEl && ctEl.value;
      var u = new URL(window.location.href);
      u.searchParams.delete('variant');
      if (ct && ct.toLowerCase() !== 'standard') u.searchParams.set('ct', ct); else u.searchParams.delete('ct');
      target = u.toString();
    } catch (e) {}
    var go = function () { if (target) window.location.href = target; else window.location.reload(); };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'phone_model': model || '' } })
    }).then(go).catch(go);
  }

  // Changing the phone reloads the page, which wipes an unsaved personalised design.
  // Warn first if one exists; only proceed if the shopper agrees to discard it.
  function guardModel(proceed) {
    if (window.FCPz && window.FCPz.hasDesign()) { window.FCPz.confirmReset(proceed); }
    else proceed();
  }

  /* Tabs inside the picker */
  function switchTab(key) {
    if (!picker) return;
    picker.querySelectorAll('[data-pp-tab]').forEach(function (t) {
      t.classList.toggle('active', t.getAttribute('data-pp-tab') === key);
    });
    picker.querySelectorAll('[data-pp-group]').forEach(function (g) {
      var on = g.getAttribute('data-pp-group') === key;
      g.classList.toggle('active', on);
      g.hidden = !on;
    });
  }

  /* Search across all models (ignores tabs while typing) */
  function runSearch(q) {
    if (!picker) return;
    q = (q || '').trim().toLowerCase();
    var groups = picker.querySelectorAll('[data-pp-group]');
    var tabs = picker.querySelector('.phone-picker__tabs');
    var noresult = picker.querySelector('[data-phone-noresult]');
    var anyShown = false;

    if (q === '') {
      if (tabs) tabs.style.display = '';
      groups.forEach(function (g) { g.hidden = !g.classList.contains('active'); });
      picker.querySelectorAll('.pp-model').forEach(function (b) { b.hidden = false; });
      if (noresult) noresult.hidden = true;
      return;
    }
    if (tabs) tabs.style.display = 'none';
    groups.forEach(function (g) { g.hidden = false; });
    picker.querySelectorAll('.pp-model').forEach(function (b) {
      var match = b.textContent.toLowerCase().indexOf(q) > -1;
      b.hidden = !match;
      if (match) anyShown = true;
    });
    if (noresult) noresult.hidden = anyShown;
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-phone-open]')) { e.preventDefault(); openPicker(); return; }
    if (e.target.closest('[data-phone-close]')) { e.preventDefault(); closePicker(); return; }
    if (e.target.closest('[data-phone-clear]')) { e.preventDefault(); guardModel(function () { setModel(''); }); return; }
    var tab = e.target.closest('[data-pp-tab]');
    if (tab) { e.preventDefault(); switchTab(tab.getAttribute('data-pp-tab')); return; }
    var model = e.target.closest('[data-model]');
    if (model) { e.preventDefault(); var mm = model.getAttribute('data-model'); guardModel(function () { setModel(mm); }); return; }

    /* Device list / shop-by-model: remember the model, then follow the link. */
    var setter = e.target.closest('[data-set-model]');
    if (setter) {
      e.preventDefault();
      var m = setter.getAttribute('data-set-model');
      var href = setter.getAttribute('href') || window.location.href;
      guardModel(function () {
        try { if (m) localStorage.setItem(KEY, m); } catch (err) {}
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { 'phone_model': m } })
        }).then(function () { window.location = href; })
          .catch(function () { window.location = href; });
      });
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-phone-search]')) runSearch(e.target.value);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && picker && picker.classList.contains('is-open')) closePicker();
  });

  /* Delayed nudge: if no model is set, after ~7s show a tooltip on the visible
     selector prompting the shopper to pick their phone. Once. */
  var TIP_KEY = 'fc_phone_tip_seen';
  function tipSeen() { try { return localStorage.getItem(TIP_KEY) === '1'; } catch (e) { return false; } }
  function markTipSeen() { try { localStorage.setItem(TIP_KEY, '1'); } catch (e) {} }

  function maybeNudge() {
    if (tipSeen()) return;
    var selectors = [].slice.call(document.querySelectorAll('.phone-chip[data-phone-set="0"], .phone-mini[data-phone-set="0"]'));
    var target = selectors.filter(function (el) { return el.offsetParent !== null; })[0];
    if (!target) return;
    target.classList.add('show-tip');
    var hide = function () { target.classList.remove('show-tip'); markTipSeen(); clearTimeout(auto); };
    var auto = setTimeout(hide, 9000);
    target.addEventListener('click', hide, { once: true });
    document.addEventListener('click', function once(e) {
      if (!target.contains(e.target)) { hide(); document.removeEventListener('click', once); }
    });
  }
  setTimeout(maybeNudge, 7000);
})();

